// src/lib/apiPublic.js
import { http } from "./axios";

// Public (guest-allowed) GETs.
// If a user is logged in, keep Authorization attached so guest-safe endpoints can
// still return user-specific fields such as engagement_summary.favorited.
// ignore401 prevents guest traffic from redirecting to /login.
export function publicGet(url, config = {}) {
    console.log('publicGet url:', url);
  return http.get(url, { ...config, ignore401: true });
}

// Public POST if you ever need it:
export function publicPost(url, data, config = {}) {
  return http.post(url, data, { ...config, ignore401: true });
}
